import { NgModule } from "@angular/core";
import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { NgxPermissionsGuard } from "ngx-permissions";

import { BlankLayoutComponent } from "./core/layouts/blank-layout/blank-layout.component";
import { BasicLayoutComponent } from "./core/layouts/basic-layout/basic-layout.component";
import { LoginComponent } from "./modules/login/login.component";
import { RegisterComponent } from "./modules/register/register.component";
import { ForgotPasswordComponent } from "./modules/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./modules/reset-password/reset-password.component";
// import { Oauth2CallbackComponent } from './shared/components/auth/oauth2-callback.component';
import { AuthGuard } from "./core/guards/auth.guard";
import { MenuResolver } from "./core/services/menu-resolver";

const routes: Routes = [
    {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full",
    },
    {
        path: "",
        component: BlankLayoutComponent,
        children: [
            { path: "login", component: LoginComponent },
            { path: "register", component: RegisterComponent },
            { path: "forgot-password", component: ForgotPasswordComponent },
            {
                path: "reset-password/:email/:token",
                component: ResetPasswordComponent,
            },
            // { path: 'reset-password/:token', component: ResetPasswordComponent },
        ],
    },
    {
        path: "",
        canActivate: [AuthGuard],
        component: BasicLayoutComponent,
        data: {
            breadcrumbs: { text: "Home" },
        },
        resolve: {
            sidebarMenu: MenuResolver,
        },
        children: [
            {
                path: "dashboard",
                pathMatch: "full",
                canActivate: [AuthGuard],
                loadChildren: () =>
                    import("./modules/home/home.module").then(
                        (m) => m.HomeModule
                    ),
                data: {
                    title: "breadcrumbs.dashboard.title",
                },
            },

            {
                path: "announcements",
                canLoad: [NgxPermissionsGuard],
                canActivate: [AuthGuard],
                data: {
                    title: "breadcrumbs.announcements.title",
                    breadcrumbs: {
                        text: "breadcrumbs.announcements.text",
                        icon: "fa fa-bullhorn",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "announcements_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/announcement/announcement.module"
                    ).then((m) => m.AnnouncementModule),
            },
            {
                path: "timesheet",
                canLoad: [NgxPermissionsGuard],
                canActivate: [AuthGuard],
                data: {
                    title: "breadcrumbs.timesheet.title",
                    breadcrumbs: {
                        text: "breadcrumbs.timesheet.text",
                        icon: "fa fa-clock-o",
                        show: false,
                        isHome: false,
                    },
                    // permissions: {
                    //     only: ["admin", "super_admin", "timesheet_view"],
                    // },
                },
                loadChildren: () =>
                    import("./modules/timesheet/timesheet.module").then(
                        (m) => m.TimesheetModule
                    ),
            },
            {
                path: "todos",
                canLoad: [NgxPermissionsGuard],
                canActivate: [AuthGuard],
                data: {
                    title: "breadcrumbs.todos.title",
                    breadcrumbs: {
                        text: "breadcrumbs.todos.text",
                        icon: "fa fa-list-ul",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "todos_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/admin/todo/todo.module").then(
                        (m) => m.TodoModule
                    ),
            },
            {
                path: "users",
                canActivate: [AuthGuard],
                //canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.users.title",
                    breadcrumbs: {
                        text: "breadcrumbs.users.text",
                        icon: "fa fa-user-circle",
                        show: false,
                        isHome: false,
                    },
                },
                loadChildren: () =>
                    import("./modules/admin/user/user.module").then(
                        (m) => m.UserModule
                    ),
            },
            {
                path: "departments",
                canActivate: [AuthGuard],
                // canLoad: [NgxPermissionsGuard],
                data: {
                    title: "Departments",
                    breadcrumbs: {
                        text: "Departments",
                        icon: "fa fa-lock",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ['admin', 'super_admin', "departments_view"]
                    }
                },
                loadChildren: () =>
                    import("./modules/admin/department/department.module").then(
                        (m) => m.departmentModule
                    ),
            },
            {
                path: "membership",
                canActivate: [AuthGuard],
                // canLoad: [NgxPermissionsGuard],
                data: {
                    title: "Membership",
                    breadcrumbs: {
                        text: "Membership",
                        icon: "fa fa-lock",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ['admin', 'super_admin', "membership_view"]
                    }
                },
                loadChildren: () =>
                    import("./modules/admin/membership/membership.module").then(
                        (m) => m.MemberShipModule
                    ),
            },
            {
                path: "roles",
                canActivate: [AuthGuard],
                // canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.roles.title",
                    breadcrumbs: {
                        text: "breadcrumbs.roles.text",
                        icon: "fa fa-lock",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ['admin', 'super_admin', "roles_view"]
                    }
                },
                loadChildren: () =>
                    import("./modules/admin/role/role.module").then(
                        (m) => m.RoleModule
                    ),
            },
            {
                path: "access",
                canActivate: [AuthGuard],
                // canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.access.title",
                    breadcrumbs: {
                        text: "breadcrumbs.access.text",
                        icon: "fa fa-lock",
                        show: false,
                        isHome: false,
                    },
                    // permissions: {
                    // 	only: ['admin', 'super_admin']
                    // }
                },
                loadChildren: () =>
                    import("./modules/admin/access/access.module").then(
                        (m) => m.AccessModule
                    ),
            },
            {
                path: "mailbox",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.mailbox.title",
                    breadcrumbs: {
                        text: "breadcrumbs.mailbox.text",
                        icon: "fa fa-envelope-o",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "mailbox_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/mailbox/mailbox.module").then(
                        (m) => m.MailboxModule
                    ),
            },
            {
                path: "file-browser",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.file_browser.title",
                    breadcrumbs: {
                        text: "breadcrumbs.file_browser.text",
                        icon: "fa fa-folder",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "filemanager_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/file-browser/file-browser.module").then(
                        (m) => m.FileBrowserModule
                    ),
            },
            {
                path: "teams",
                canActivate: [AuthGuard],
                //canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.teams.title",
                    breadcrumbs: {
                        text: "breadcrumbs.teams.text",
                        icon: "fa fa-universal-access",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "teams_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/admin/team/team.module").then(
                        (m) => m.TeamModule
                    ),
            },
            {
                path: "holidays",
                canActivate: [AuthGuard],
                //canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.holidays.title",
                    breadcrumbs: {
                        text: "breadcrumbs.holidays.text",
                        icon: "fa fa-calendar-plus-o",
                        show: false,
                        isHome: false,
                    },
                    // permissions: {
                    //     only: ["admin", "super_admin", "holidays_view"],
                    // },
                },
                loadChildren: () =>
                    import("./modules/admin/holiday/holiday.module").then(
                        (m) => m.HolidayModule
                    ),
            },
            {
                path: "meetings",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.meetings.title",
                    breadcrumbs: {
                        text: "breadcrumbs.meetings.text",
                        icon: "fa fa-briefcase",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "meetings_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/admin/meeting/meeting.module").then(
                        (m) => m.MeetingModule
                    ),
            },
            {
                path: "clients",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.clients.title",
                    breadcrumbs: {
                        text: "breadcrumbs.clients.text",
                        icon: "fa fa-user-circle",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "clients_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/admin/client/client.module").then(
                        (m) => m.ClientModule
                    ),
            },
            {
                path: "product-labels",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.product_labels.title",
                    breadcrumbs: {
                        text: "breadcrumbs.product_labels.text",
                        icon: "fa fa-user-circle",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'productslabels_view']
                    }
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/ecommerce/product_labels/product_labels.module"
                    ).then((m) => m.ProductlabelsModule),
            },
            {
                path: "product-option",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.product_options.title",
                    breadcrumbs: {
                        text: "breadcrumbs.product_options.text",
                        icon: "fa fa-user-circle",
                        show: false,
                        isHome: false,
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/ecommerce/product_option/product_option.module"
                    ).then((m) => m.ProductOptionModule),
            },
            {
                path: "product-collection",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.product_collection.title",
                    breadcrumbs: {
                        text: "breadcrumbs.product_collection.text",
                        icon: "fa fa-user-circle",
                        show: false,
                        isHome: false,
                    },
                    // permissions: {
                    // 	only: ['admin', 'super_admin', 'productcollection_view']
                    // }
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/ecommerce/product_collection/product_collection.module"
                    ).then((m) => m.ProductCollectionModule),
            },

            {
                path: "products",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.products.title",
                    breadcrumbs: {
                        text: "breadcrumbs.products.text",
                        icon: "fa fa-user-circle",
                        show: false,
                        isHome: false,
                    },
                    // permissions: {
                    // 	only: ['admin', 'super_admin', 'clients_view']
                    // }
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/ecommerce/product/products.module"
                    ).then((m) => m.ProductsModule),
            },
            {
                path: "product-orders",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.product_order.title",
                    breadcrumbs: {
                        text: "breadcrumbs.product_order.text",
                        icon: "fa fa-user-circle",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'productorders_view']
                    }
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/ecommerce/product_orders/product_orders.module"
                    ).then((m) => m.ProductsOrderModule),
            },
            {
                path: "product-attribute",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.product_attributes.title",
                    breadcrumbs: {
                        text: "breadcrumbs.product_attributes.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permission: {
                        only: [
                            "admin",
                            "super_admin",
                            "productattributes_view",
                        ],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/ecommerce/product_attribute/product_attribute.module"
                    ).then((m) => m.ProductAttributeModule),
            },
            {
                path: "product-tags",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.product_tags.title",
                    breadcrumbs: {
                        text: "breadcrumbs.product_tags.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permission: {
                        only: ["admin", "super_admin", "producttags_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/ecommerce/product_tags/product_tags.module"
                    ).then((m) => m.ProductTagsModule),
            },
            {
                path: "product-price",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.product_price.title",
                    breadcrumbs: {
                        text: "breadcrumbs.product_price.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    // permission:{
                    // 	only:['admin','super_admin','productprice_view']
                    // }
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/ecommerce/product_price/product_price.module"
                    ).then((m) => m.ProductPriceModule),
            },
            {
                path: "product-inventory",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.product_inventory.title",
                    breadcrumbs: {
                        text: "breadcrumbs.product_inventory.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    // permission:{
                    // 	only:['admin','super_admin','productinventory_view']
                    // }
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/ecommerce/product_Inventory/product_inventory.module"
                    ).then((m) => m.ProductInventoryModule),
            },
            {
                path: "product-categories",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.product_categories.title",
                    breadcrumbs: {
                        text: "breadcrumbs.product_categories.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    // permission: {
                    //     only: ["admin", "super_admin", "productcategories_view"],
                    // },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/ecommerce/product_categories/product_categories.module"
                    ).then((m) => m.ProductCategoriesModule),
            },
            {
                path: "invoice",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.invoice.title",
                    breadcrumbs: {
                        text: "breadcrumbs.invoice.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permission: {
                        only: ["admin", "super_admin", "producttags_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/ecommerce/invoice/invoice.module"
                    ).then((m) => m.ProductInvoiceModule),
            },
            {
                path: "discounts",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.discounts.title",
                    breadcrumbs: {
                        text: "breadcrumbs.discounts.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permission: {
                        only: ["admin", "super_admin", "discounts_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/ecommerce/product-discount/product-discount.module"
                    ).then((m) => m.ProductDiscountModule),
            },
            {
                path: "shipping",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.shipping.title",
                    breadcrumbs: {
                        text: "breadcrumbs.shipping.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    // permission: {
                    //     only: ["admin", "super_admin", "productshipping_view"],
                    // },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/ecommerce/product_shipping/product_shipping.module"
                    ).then((m) => m.ProductShippingModule),
            },

            {
                path: "all-business-account",
                canActivate: [AuthGuard],
                // canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.business_account.title",
                    breadcrumbs: {
                        text: "breadcrumbs.business_account.text",
                        icon: "fa fa-user-circle",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                    	only: ['admin', 'super_admin', 'allbusinessaccount_view']
                    }
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/business_accounts/all-business-account/all-business-account.module"
                    ).then((m) => m.AllBusinessAccountModule),
            },
            {
                path: "my-connection",
                canActivate: [AuthGuard],
                // canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.my_connection.title",
                    breadcrumbs: {
                        text: "breadcrumbs.my_connection.text",
                        icon: "fa fa-user-circle",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                    	only: ['admin', 'super_admin', 'myconnection_view']
                    }
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/business_accounts/my-connections/my-connections.module"
                    ).then((m) => m.MyConnectionModule),
            },

            {
                path: "business-request",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.business_request.title",
                    breadcrumbs: {
                        text: "breadcrumbs.business_request.text",
                        icon: "fa fa-user-circle",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                    	only: ['admin', 'super_admin', 'businesstypes_view']
                    }
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/business_accounts/business-request/business-request.module"
                    ).then((m) => m.BusinessRequestModule),
            },
            {
                path: "settings",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.settings.title",
                    breadcrumbs: {
                        text: "breadcrumbs.settings.text",
                        icon: "fa fa-cogs",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "settings_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/settings/settings.module").then(
                        (m) => m.SettingsModule
                    ),
            },
            {
                path: "calendar",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.calendar.title",
                    breadcrumbs: {
                        text: "breadcrumbs.calendar.text",
                        icon: "fa fa-calendar",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "calendar_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/calendar-pm/calendar-pm.module").then(
                        (m) => m.CalendarPmModule
                    ),
            },
            {
                path: "projects",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.projects.title",
                    breadcrumbs: {
                        text: "breadcrumbs.projects.text",
                        icon: "fa fa-product-hunt",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "projects_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/pm/projects/projects.module").then(
                        (m) => m.ProjectsModule
                    ),
            },
            {
                path: "production",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "Production",
                    breadcrumbs: {
                        text: "Production",
                        icon: "fa fa-product-hunt",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: [
                            "admin",
                            "super_admin",
                            "production_view",
                        ],
                    },
                },
                loadChildren: () =>
                    import("./modules/pm/production/production.module").then(
                        (m) => m.ProductionModule
                    ),
            },
            {
                path: "tasks",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.tasks.title",
                    breadcrumbs: {
                        text: "breadcrumbs.tasks.text",
                        icon: "fa fa-tasks",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "tasks_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/pm/tasks/tasks.module").then(
                        (m) => m.TasksModule
                    ),
            },
            {
                path: "defects",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.defects.title",
                    breadcrumbs: {
                        text: "breadcrumbs.defects.text",
                        icon: "fa fa-bug",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "defects_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/pm/defects/defects.module").then(
                        (m) => m.DefectsModule
                    ),
            },
            {
                path: "support-ticket",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.support_ticket.title",
                    breadcrumbs: {
                        text: "breadcrumbs.support_ticket.text",
                        icon: "fa fa-ticket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "supportticket_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/pm/support-ticket/suppport-ticket.module"
                    ).then((m) => m.SuppoetTicketModule),
            },
            {
                path: "taskboard",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.taskboard.title",
                    breadcrumbs: {
                        text: "breadcrumbs.taskboard.text",
                        icon: "fa fa-clipboard",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "tasks_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/pm/task-board/task-board.module").then(
                        (m) => m.TaskBoardModule
                    ),
            },
            {
                path: "teamboard",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.teamboard.title",
                    breadcrumbs: {
                        text: "breadcrumbs.teamboard.text",
                        icon: "fa fa-universal-access",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "teams_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/pm/team-board/team-board.module").then(
                        (m) => m.TeamBoardModule
                    ),
            },
            {
                path: "projects-planner",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.projects_planner.title",
                    breadcrumbs: {
                        text: "breadcrumbs.projects_planner.text",
                        icon: "fa fa-american-sign-language-interpreting",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "projectplanner_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/pm/project-planner/project-planner.module"
                    ).then((m) => m.ProjectPlannerModule),
            },
            {
                path: "knowledgebase",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.knowledgebase.title",
                    breadcrumbs: {
                        text: "breadcrumbs.knowledgebase.text",
                        icon: "fa fa-graduation-cap",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "knowledgebase_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/pm/knowledgebase/knowledgebase.module"
                    ).then((m) => m.KnowledgebaseModule),
            },
            {
                path: "product-tree",
                canActivate: [AuthGuard],
                // canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.product-tree.title",
                    breadcrumbs: {
                        text: "breadcrumbs.product-tree.text",
                        icon: "fa fa-graduation-cap",
                        show: false,
                        isHome: false,
                    },
                    // permissions: {
                    // 	only: ['admin', 'super_admin', 'knowledgebase_view']
                    // }
                },
                loadChildren: () =>
                    import(
                        "./modules/sales/product-tree/product-tree.module"
                    ).then((m) => m.ProductTreeModule),
            },
            {
                path: "reports",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.reports.title",
                    breadcrumbs: {
                        text: "breadcrumbs.reports.text",
                        icon: "fa fa-bar-chart",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "reports_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/pm/reports/reports.module").then(
                        (m) => m.ReportsModule
                    ),
            },
            {
                path: "appointments",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.appointments.title",
                    breadcrumbs: {
                        text: "breadcrumbs.appointments.text",
                        icon: "fa fa-calendar-plus-o",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "appointment_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/crm/appointments/appointments.module"
                    ).then((m) => m.AppointmentsModule),
            },
            {
                path: "providers",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.providers.title",
                    breadcrumbs: {
                        text: "breadcrumbs.providers.text",
                        icon: "fa fa-industry",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin"],
                    },
                },
                loadChildren: () =>
                    import("./modules/crm/providers/providers.module").then(
                        (m) => m.ProvidersModule
                    ),
            },
            {
                path: "leaves",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.leaves.title",
                    breadcrumbs: {
                        text: "breadcrumbs.leaves.text",
                        icon: "fa fa-suitcase",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "leaves_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/hrm/leaves/leaves.module").then(
                        (m) => m.LeavesModule
                    ),
            },
            {
                path: "attendance",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "Attendance",
                    breadcrumbs: {
                        text: "Attendance",
                        icon: "fa fa-suitcase",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "attendance_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/hrm/attendance/attendance.module").then(
                        (m) => m.AttendanceModule
                    ),
            },
            {
                path: "leave-types",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.leave_types.title",
                    breadcrumbs: {
                        text: "breadcrumbs.leave_types.text",
                        icon: "fa fa-trello",
                        show: false,
                        isHome: false,
                    },
                    // permissions: {
                    //     only: ["admin", "super_admin", "leavetypes_view"],
                    // },
                },
                loadChildren: () =>
                    import("./modules/hrm/leave-types/leave-types.module").then(
                        (m) => m.LeaveTypesModule
                    ),
            },
            {
                path: "taxes",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.taxes.title",
                    breadcrumbs: {
                        text: "breadcrumbs.taxes.text",
                        icon: "fa fa-percent",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                    	only: ['admin', 'super_admin', 'taxes_view']
                    }
                },
                loadChildren: () =>
                    import("./modules/sales/taxes/taxes.module").then(
                        (m) => m.TaxesModule
                    ),
            },
            {
                path: "industrytype",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.industrytype.title",
                    breadcrumbs: {
                        text: "breadcrumbs.industrytype.text",
                        icon: "fa fa-percent",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "industrytypes_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/sales/industrytype/industrytype.module"
                    ).then((m) => m.IndustrytypeModule),
            },
            {
                path: "categorymaster",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.categorymaster.title",
                    breadcrumbs: {
                        text: "breadcrumbs.categorymaster.text",
                        icon: "fa fa-percent",
                        show: false,
                        isHome: false,
                    },
                    // permissions: {
                    // 	only: ['admin', 'super_admin', 'categorymaster_view']
                    // }
                },
                loadChildren: () =>
                    import(
                        "./modules/sales/categorymaster/categorymaster.module"
                    ).then((m) => m.CategorymasterModule),
            },
            {
                path: "items",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.items.title",
                    breadcrumbs: {
                        text: "breadcrumbs.items.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "items_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/sales/items/items.module").then(
                        (m) => m.ItemsModule
                    ),
            },
            {
                path: "product-brand",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.product_brand.title",
                    breadcrumbs: {
                        text: "breadcrumbs.product_brand.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "items_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/sales/product-brand/product-brand.module"
                    ).then((m) => m.ProductBrandModule),
            },
            {
                path: "product-tags",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.product_tags.title",
                    breadcrumbs: {
                        text: "breadcrumbs.product_tags.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "producttags_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/sales/product-tags/product-tags.module"
                    ).then((m) => m.ProductTagsModule),
            },
            {
                path: "table",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.table.title",
                    breadcrumbs: {
                        text: "breadcrumbs.table.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "items_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/sales/table/table.module").then(
                        (m) => m.TableModule
                    ),
            },
            {
                path: "type",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.items.title",
                    breadcrumbs: {
                        text: "breadcrumbs.items.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "items_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/sales/type/type.module").then(
                        (m) => m.TypeModule
                    ),
            },
            {
                path: "estimates",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.estimates.title",
                    breadcrumbs: {
                        text: "breadcrumbs.estimates.text",
                        icon: "fa fa-external-link",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "estimates_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/sales/estimates/estimates.module").then(
                        (m) => m.EstimatesModule
                    ),
            },
            {
                path: "invoices",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.invoices.title",
                    breadcrumbs: {
                        text: "breadcrumbs.invoices.text",
                        icon: "fa fa-file-pdf-o",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "invoices_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/sales/invoices/invoices.module").then(
                        (m) => m.InvoicesModule
                    ),
            },
            {
                path: "payments",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.payments.title",
                    breadcrumbs: {
                        text: "breadcrumbs.payments.text",
                        icon: "fa fa-money",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "payments_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/sales/payments/payments.module").then(
                        (m) => m.PaymentsModule
                    ),
            },
            {
                path: "table",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.table.title",
                    breadcrumbs: {
                        text: "breadcrumbs.table.text",
                        icon: "fa fa-money",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "payments_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/sales/table/table.module").then(
                        (m) => m.TableModule
                    ),
            },
            {
                path: "profile/:slug",
                canActivate: [AuthGuard],
                // canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.profile.title",
                    breadcrumbs: {
                        text: "breadcrumbs.profile.text",
                        icon: "fa fa-bullhorn",
                        show: false,
                        isHome: false,
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/sales/public-profile/public-profile.module"
                    ).then((m) => m.PublicProfileModule),
            },
            {
                path: "master",
                canActivate: [AuthGuard],
                // canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.profile.title",
                    breadcrumbs: {
                        text: "breadcrumbs.profile.text",
                        icon: "fa fa-bullhorn",
                        show: false,
                        isHome: false,
                    },
                    // permissions: {
                    // 	only: ['admin', 'super_admin', 'announcements_view']
                    // }
                },
                loadChildren: () =>
                    import("./modules/sales/Master/master.module").then(
                        (m) => m.MasterModule
                    ),
            },
            {
                path: "productlist",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.product_list.title",
                    breadcrumbs: {
                        text: "breadcrumbs.product_list.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "productlist_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/sales/productlist/productlist.module"
                    ).then((m) => m.ProductlistModule),
            },
            {
                path: "specification-attribute",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.specification_attribute.title",
                    breadcrumbs: {
                        text: "breadcrumbs.specification_attribute.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "specificationattribute_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/product-specification/specification-attributes/specification-attributes.module"
                    ).then((m) => m.SpecificationAttributesModule),
            },
            {
                path: "payment-transactions",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.payment_transaction.title",
                    breadcrumbs: {
                        text: "breadcrumbs.payment_transaction.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "paymenttransactions_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/payments/transactions/transactions.module"
                    ).then((m) => m.TransactionsModule),
            },
            {
                path: "payment-logs",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.payment_logs.title",
                    breadcrumbs: {
                        text: "breadcrumbs.payment_logs.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "paymentlogs_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/payments/payment-logs/payment-logs.module"
                    ).then((m) => m.PaymentLogsModule),
            },
            {
                path: "payment-methods",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.payment_methods.title",
                    breadcrumbs: {
                        text: "breadcrumbs.payment_methods.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "paymentmethods_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/payments/payment-methods/payment-methods.module"
                    ).then((m) => m.PaymentMethodsModule),
            },
            {
                path: "faqs",
                canLoad: [NgxPermissionsGuard],
                canActivate: [AuthGuard],
                data: {
                    title: "breadcrumbs.faqs.title",
                    breadcrumbs: {
                        text: "breadcrumbs.faqs.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "faqs_view"],
                    },
                },
                loadChildren: () =>
                    import("./modules/admin/faqs/faqs/faqs.module").then(
                        (m) => m.FaqsModule
                    ),
            },
            {
                path: "faq-categories",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.faq_categories.title",
                    breadcrumbs: {
                        text: "breadcrumbs.faq_categories.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "faq-categories_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/faqs/categories/categories.module"
                    ).then((m) => m.CategoriesModule),
            },
            {
                path: "product-tax",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.product_tax.title",
                    breadcrumbs: {
                        text: "breadcrumbs.product_tax.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "producttax_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/ecommerce/product-tax/product-tax.module"
                    ).then((m) => m.ProductTaxModule),
            },

            {
                path: "specification-table",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.specification_table.title",
                    breadcrumbs: {
                        text: "breadcrumbs.specification_table.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "specificationtable_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/product-specification/specification-table/specification-table.module"
                    ).then((m) => m.SpecificationTableModule),
            },
            {
                path: "specification-group",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.specification_groups.title",
                    breadcrumbs: {
                        text: "breadcrumbs.specification_groups.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "specificationgroup_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/product-specification/specification-groups/specification-groups.module"
                    ).then((m) => m.SpecificationGroupsModule),
            },
            {
                path: "shipments",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.shipments.title",
                    breadcrumbs: {
                        text: "breadcrumbs.shipments.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "shipments_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/ecommerce/shipments/shipments.module"
                    ).then((m) => m.ShipmentsModule),
            },
            {
                path: "employee-salaries",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.salary.title",
                    breadcrumbs: {
                        text: "breadcrumbs.salary.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "employeesalaries_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/hrm/payroll-management/employee-salary/salary.module"
                    ).then((m) => m.SalaryModule),
            },
            {
                path: "chat-box",
                canActivate: [AuthGuard],
                loadChildren: () =>
                    import("./modules/chat/chat.module").then(
                        (m) => m.ChatModule
                    ),
                data: {
                    title: "breadcrumbs.salary.title",
                    breadcrumbs: {
                        text: "breadcrumbs.salary.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "items_view"],
                    },
                },
            },
            {
                path: "tax-report",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.taxReport.title",
                    breadcrumbs: {
                        text: "breadcrumbs.taxReport.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "items_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/hrm/payroll-management/tax-report/taxReport.module"
                    ).then((m) => m.TaxReportModule),
            },
            {
                path: "advance-salaries",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.advanceSalary.title",
                    breadcrumbs: {
                        text: "breadcrumbs.advanceSalary.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "advancesalaries_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/hrm/payroll-management/advance-salary/advanceSalary.module"
                    ).then((m) => m.AdvanceSalaryModule),
            },
            {
                path: "payroll",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.payroll.title",
                    breadcrumbs: {
                        text: "breadcrumbs.payroll.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "payroll_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/hrm/payroll-management/payroll/payroll.module"
                    ).then((m) => m.PayrollModule),
            },
            {
                path: "payroll-setting",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.payrollSetting.title",
                    breadcrumbs: {
                        text: "breadcrumbs.payrollSetting.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "payrollsetting_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/hrm/payroll-management/payroll-setting/salary-setting/selarySetting.module"
                    ).then((m) => m.SalarySettingModule),
            },

            {
                path: "shift-management",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.shiftManagement.title",
                    breadcrumbs: {
                        text: "breadcrumbs.shiftManagement.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permissions: {
                        only: ["admin", "super_admin", "shiftmanagement_view"],
                    },
                },
                loadChildren: () =>
                    import(
                        "./modules/admin/office_configuration/shift_management/shift_management.module"
                    ).then((m) => m.ShiftManagementModule),
            },
            {
                path: "fiscal_year",
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.fiscalYear.title",
                    breadcrumbs: {
                        text: "breadcrumbs.fiscalYear.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false,
                    },
                    permission: {
                        only: ["admin", "super_admin", "fiscalyear_view"],
                    },
                },
                loadChildren: () => import('./modules/admin/office_configuration/fiscal-year/fiscatlYear.module').then(m => m.FiscalModule)
            },

            {
                path: 'specification-table',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.specification_table.title",
                    breadcrumbs: {
                        text: "breadcrumbs.specification_table.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'items_view']
                    }
                },
                loadChildren: () => import('./modules/admin/product-specification/specification-table/specification-table.module').then(m => m.SpecificationTableModule)
            },
            {
                path: 'specification-group',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.specification_groups.title",
                    breadcrumbs: {
                        text: "breadcrumbs.specification_groups.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'items_view']
                    }
                },
                loadChildren: () => import('./modules/admin/product-specification/specification-groups/specification-groups.module').then(m => m.SpecificationGroupsModule)
            },
            {
                path: 'shipments',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.shipments.title",
                    breadcrumbs: {
                        text: "breadcrumbs.shipments.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'items_view']
                    }
                },
                loadChildren: () => import('./modules/admin/ecommerce/shipments/shipments.module').then(m => m.ShipmentsModule)
            },
            {
                path: 'employee-salaries',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.salary.title",
                    breadcrumbs: {
                        text: "breadcrumbs.salary.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'items_view']
                    }
                },
                loadChildren: () => import('./modules/hrm/payroll-management/employee-salary/salary.module').then(m => m.SalaryModule)
            },
            {
                path: 'chat-box',
                canActivate: [AuthGuard],
                loadChildren: () => import('./modules/chat/chat.module').then(m => m.ChatModule),
                data: {
                    title: "breadcrumbs.salary.title",
                    breadcrumbs: {
                        text: "breadcrumbs.salary.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'items_view']
                    }
                },
            },
            {
                path: 'tax-report',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.taxReport.title",
                    breadcrumbs: {
                        text: "breadcrumbs.taxReport.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'items_view']
                    }
                },
                loadChildren: () => import('./modules/hrm/payroll-management/tax-report/taxReport.module').then(m => m.TaxReportModule)
            },
            {
                path: 'advance-salaries',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.advanceSalary.title",
                    breadcrumbs: {
                        text: "breadcrumbs.advanceSalary.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'advancesalaries_view']
                    }
                },
                loadChildren: () => import('./modules/hrm/payroll-management/advance-salary/advanceSalary.module').then(m => m.AdvanceSalaryModule)
            },
            {
                path: 'payroll',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.payroll.title",
                    breadcrumbs: {
                        text: "breadcrumbs.payroll.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'payroll_view']
                    }
                },
                loadChildren: () => import('./modules/hrm/payroll-management/payroll/payroll.module').then(m => m.PayrollModule)
            },
            {
                path: 'payroll-setting',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.payrollSetting.title",
                    breadcrumbs: {
                        text: "breadcrumbs.payrollSetting.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'payrollsetting_view']
                    }
                },
                loadChildren: () => import('./modules/hrm/payroll-management/payroll-setting/salary-setting/selarySetting.module').then(m => m.SalarySettingModule)
            },
            {
                path: 'designation',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.designation.title",
                    breadcrumbs: {
                        text: "breadcrumbs.designation.text",
                        icon: "fa fa-suitcase",
                        show: false,
                        isHome: false
                    }
                },
                loadChildren: () => import('./modules/hrm/designation/designation.module').then(m => m.DesignationModule)
            },
            {
                path: 'document-verification',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.documentVarification.title",
                    breadcrumbs: {
                        text: "breadcrumbs.documentVarification.text",
                        icon: "fa fa-suitcase",
                        show: false,
                        isHome: false
                    }
                },
                loadChildren: () => import('./modules/profile/docement-varification/documentVarification.module').then(m => m.DocumentVarificationModule)
            },

            {
                path: 'terms-and-conditions',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.terms_and_conditions.title",
                    breadcrumbs: {
                        text: "breadcrumbs.terms_and_conditions.text",
                        icon: "fa fa-suitcase",
                        show: false,
                        isHome: false
                    }
                },
                loadChildren: () => import('./modules/profile/terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsModule)
            },

            {
                path: 'shift-management',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.shiftManagement.title",
                    breadcrumbs: {
                        text: "breadcrumbs.shiftManagement.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'items_view']
                    }
                },

                loadChildren: () => import('./modules/admin/office_configuration/shift_management/shift_management.module').then(m => m.ShiftManagementModule)
            },
            // {
            // 	path: 'fiscal_year',
            // 	canActivate: [AuthGuard],
            // 	canLoad: [NgxPermissionsGuard],
            // 	data: {
            // 		title: "breadcrumbs.fiscalYear.title",
            // 		breadcrumbs: {
            // 			text: "breadcrumbs.fiscalYear.text"},
            // 		},
            // 	loadChildren: () => import('./modules/admin/office_configuration/fiscal-year/shift_management.module').then(m => m.FiscalModule)
            // },
            {
                path: 'awards',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.awards.title",
                    breadcrumbs: {
                        text: "breadcrumbs.awards.text",
                    }
                },
                loadChildren: () => import('./modules/admin/award_managment/awards/awards.module').then(m => m.AwardsModule)
            },
            {
                path: 'awards-types',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.awards_types.title",
                    breadcrumbs: {
                        text: "breadcrumbs.awards_types.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'items_view']
                    }
                },
                loadChildren: () => import('./modules/admin/award_managment/award_types/award_types.module').then(m => m.AwardTypesModule)

            },
            {
                path: 'warehouse',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.warehouse.title",
                    breadcrumbs: {
                        text: "breadcrumbs.warehouse.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'warehouse_view']
                    }
                },

                loadChildren: () => import('./modules/warehouse/warehouse/warehosue.module').then(m => m.WarehosueModule)
            },
            {
                path: 'division',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.division.title",
                    breadcrumbs: {
                        text: "breadcrumbs.division.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'division_view']
                    }
                },

                loadChildren: () => import('./modules/warehouse/division/division.module').then(m => m.DivisionModule)
            },
            {
                path: 'reck',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.reck.title",
                    breadcrumbs: {
                        text: "breadcrumbs.reck.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'reck_view']
                    }
                },

                loadChildren: () => import('./modules/warehouse/reck/reck.module').then(m => m.ReckModule)
            },
            {
                path: 'drawer',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.drawer.title",
                    breadcrumbs: {
                        text: "breadcrumbs.drawer.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'drawer_view']
                    }
                },

                loadChildren: () => import('./modules/warehouse/drawer/drawer.module').then(m => m.DrawerModule)
            },
            {
                path: 'product_checkins',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.product_checkins.title",
                    breadcrumbs: {
                        text: "breadcrumbs.product_checkins.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'productcheckins_view']
                    }
                },

                loadChildren: () => import('./modules/checkins/product_checkins/product_checkins.module').then(m => m.ProdcutCheckinsModule)
            },
            {
                path: 'accessories_checkins',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.accessories_checkins.title",
                    breadcrumbs: {
                        text: "breadcrumbs.accessories_checkins.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'accessoriescheckins_view']
                    }
                },

                loadChildren: () => import('./modules/checkins/accessories_checkins/accessories_checkins.module').then(m => m.AccessorieCheckinsModule)
            },
            {
                path: 'consumable_checkins',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.consumable_checkins.title",
                    breadcrumbs: {
                        text: "breadcrumbs.consumable_checkins.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'consumablecheckins_view']
                    }
                },

                loadChildren: () => import('./modules/checkins/consumable_checkins/consumable_checkins.module').then(m => m.ConsumableCheckinsModule)
            },
            {
                path: 'product_checkouts',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.product_checkouts.title",
                    breadcrumbs: {
                        text: "breadcrumbs.product_checkouts.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'productcheckouts_view']
                    }
                },

                loadChildren: () => import('./modules/checkouts/product_checkouts/product_checkouts.module').then(m => m.ProdcutCheckoutsModule)
            },
            {
                path: 'accessories_checkouts',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.accessories_checkouts.title",
                    breadcrumbs: {
                        text: "breadcrumbs.accessories_checkouts.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'accessoriescheckouts_view']
                    }
                },

                loadChildren: () => import('./modules/checkouts/accessories_checkouts/accessories_checkouts.module').then(m => m.AccessorieCheckoutsModule)
            },
            {
                path: 'consumable_checkouts',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.consumable_checkouts.title",
                    breadcrumbs: {
                        text: "breadcrumbs.consumable_checkouts.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'consumablecheckouts_view']
                    }
                },

                loadChildren: () => import('./modules/checkouts/consumable_checkouts/consumable_checkouts.module').then(m => m.ConsumableCheckoutsModule)
            },
            {
                path: 'adjustments',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.adjustments.title",
                    breadcrumbs: {
                        text: "breadcrumbs.adjustments.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    // permissions: {
                    //     only: ['admin', 'super_admin', 'items_view']
                    // }
                },

                loadChildren: () => import('./modules/adjustments/adjustments.module').then(m => m.AdjustmentsModule)
            },
            {
                path: 'transfer',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.transfer.title",
                    breadcrumbs: {
                        text: "breadcrumbs.transfer.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'transfer_view']
                    }
                },

                loadChildren: () => import('./modules/transfer/transfer.module').then(m => m.TransferModule)
            },
            {
                path: 'product-details_labels',
                canActivate: [AuthGuard],
                canLoad: [NgxPermissionsGuard],
                data: {
                    title: "breadcrumbs.product-details_labels.title",
                    breadcrumbs: {
                        text: "breadcrumbs.product-details_labels.text",
                        icon: "fa fa-shopping-basket",
                        show: false,
                        isHome: false
                    },
                    permissions: {
                        only: ['admin', 'super_admin', 'items_view']
                    }
                },

                loadChildren: () => import('./modules/admin/ecommerce/product-details_labels/product-details_labels.module').then(m => m.ProductDetailslabelsModule)
            },
        ]
    },

    // // Handle all other routes
    { path: "**", redirectTo: "" },
    //{path:'app-oauth2-callback', component : Oauth2CallbackComponent}
];

const config: ExtraOptions = {
    useHash: true,
    scrollPositionRestoration: "top",
};

@NgModule({
    imports: [RouterModule.forRoot(routes, config)],
    exports: [RouterModule],
    providers: [MenuResolver],
})
export class AppRoutingModule { }
